export interface DaysProps {
  day: number;
  selectionActive: boolean;
  isFrom: boolean;
  isFromInterval: boolean;
  isTo: boolean;
  isEqual: boolean;
  type: DayTypeEnum;
  isAvailable: boolean;
  isWeekend: boolean;
  onDayClick: (day: number) => void;
  onHoverDay: (day: number) => void;
}

export enum DayTypeEnum {
  LastDay = 0,
  ActualDay,
  FutureDay,
}
